import React, { useMemo, useState, createElement } from 'react';
import { DollarSign, Search, Download, Eye, CreditCard, ArrowUpRight, ArrowDownRight, RefreshCw, AlertTriangle, CheckCircle2, Clock, XCircle, Tag, MoreVertical, Calendar, Globe, FileSpreadsheet, ExternalLink, User as UserIcon, Star as StarIcon, TrendingUp, BarChart3, ChevronDown, X, FileText, MapPin, Banknote, Receipt, ArrowRight, Info, History, Wallet, Settings, Repeat, PauseCircle, Ban, ListOrdered, DownloadCloud, MessageSquare, Video, Scale } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
import { Pagination } from '../ui/Pagination';
interface AdminFinanceFullManagerProps {
  orders: any[];
  users: any[];
  astrologers: any[];
  refunds: any[];
  setActiveTab: (tab: string) => void;
  setDetailPanel: (panel: any) => void;
  success: (msg: string) => void;
}
// --- MOCK DATA ---
const mockPayments = [{
  id: 'PAY-5001',
  order: 'ORD-1201',
  user: 'Анна Петрова',
  astrologer: 'Мария Звёздная',
  category: 'Натальная карта',
  orderType: 'AI отчет',
  amount: 4900,
  commission: 735,
  netIncome: 735,
  method: 'Карта Visa',
  provider: 'ЮKassa',
  country: 'RU',
  status: 'success',
  date: '16.03.2026 14:22',
  risk: null,
  refundReason: null,
  log: [{
    date: '16.03.2026 14:20',
    action: 'Платеж создан',
    status: 'pending'
  }, {
    date: '16.03.2026 14:22',
    action: 'Успешно проведён',
    status: 'success'
  }]
}, {
  id: 'PAY-5002',
  order: 'ORD-1202',
  user: 'Иван Сидоров',
  astrologer: 'Алексей Лунный',
  category: 'Совместимость',
  orderType: 'Консультация',
  amount: 3500,
  commission: 525,
  netIncome: 525,
  method: 'Apple Pay',
  provider: 'Stripe',
  country: 'DE',
  status: 'success',
  date: '16.03.2026 11:45',
  risk: null,
  refundReason: null,
  log: [{
    date: '16.03.2026 11:44',
    action: 'Платеж создан',
    status: 'pending'
  }, {
    date: '16.03.2026 11:45',
    action: 'Успешно проведён',
    status: 'success'
  }]
}, {
  id: 'PAY-5003',
  order: 'ORD-1203',
  user: 'Maria Schmidt',
  astrologer: '—',
  category: 'AI Прогноз',
  orderType: 'AI отчет',
  amount: 1990,
  commission: 1990,
  netIncome: 1990,
  method: 'PayPal',
  provider: 'PayPal',
  country: 'US',
  status: 'success',
  date: '15.03.2026 18:30',
  risk: null,
  refundReason: null,
  log: [{
    date: '15.03.2026 18:29',
    action: 'Платеж создан',
    status: 'pending'
  }, {
    date: '15.03.2026 18:30',
    action: 'Успешно проведён',
    status: 'success'
  }]
}, {
  id: 'PAY-5004',
  order: 'ORD-1204',
  user: 'Олег Козлов',
  astrologer: 'Ольга Солнцева',
  category: 'Консультация',
  orderType: 'Консультация',
  amount: 7500,
  commission: 1125,
  netIncome: 0,
  method: 'Карта Mir',
  provider: 'ЮKassa',
  country: 'RU',
  status: 'error',
  date: '15.03.2026 09:15',
  risk: 'ошибка',
  refundReason: null,
  log: [{
    date: '15.03.2026 09:14',
    action: 'Платеж создан',
    status: 'pending'
  }, {
    date: '15.03.2026 09:15',
    action: 'Отклонено банком (Недостаточно средств)',
    status: 'error'
  }]
}, {
  id: 'PAY-5005',
  order: 'ORD-1205',
  user: 'Елена Волкова',
  astrologer: 'Мария Звёздная',
  category: 'Комбо',
  orderType: 'Услуга',
  amount: 8900,
  commission: 1335,
  netIncome: -150,
  method: 'Карта Visa',
  provider: 'Stripe',
  country: 'US',
  status: 'refund',
  date: '14.03.2026 16:40',
  risk: 'возврат',
  refundReason: 'Жалоба клиента',
  log: [{
    date: '12.03.2026 10:00',
    action: 'Платеж создан',
    status: 'pending'
  }, {
    date: '12.03.2026 10:02',
    action: 'Успешно проведён',
    status: 'success'
  }, {
    date: '14.03.2026 16:30',
    action: 'Запрос на возврат',
    status: 'warning'
  }, {
    date: '14.03.2026 16:40',
    action: 'Возврат оформлен',
    status: 'refund'
  }]
}, {
  id: 'PAY-5006',
  order: 'ORD-1206',
  user: 'John Doe',
  astrologer: '—',
  category: 'Курс Таро',
  orderType: 'Курс',
  amount: 15000,
  commission: 15000,
  netIncome: -500,
  method: 'Карта Mastercard',
  provider: 'Stripe',
  country: 'UK',
  status: 'chargeback',
  date: '13.03.2026 12:00',
  risk: 'chargeback',
  refundReason: 'Фрод / Чарджбэк',
  log: [{
    date: '01.03.2026 12:00',
    action: 'Успешно проведён',
    status: 'success'
  }, {
    date: '13.03.2026 12:00',
    action: 'Chargeback получен',
    status: 'error'
  }]
}];
const mockPayouts = [{
  id: 'PO-301',
  astrologer: 'Мария Звёздная',
  country: 'RU',
  period: '01–15 марта',
  orders: 24,
  consultations: 8,
  total: 142000,
  commission: 21300,
  refunds: 4500,
  payout: 116200,
  status: 'paid',
  date: '16.03.2026',
  method: 'Bank transfer',
  autoPayout: 'monthly',
  balance: {
    available: 0,
    pending: 45000,
    frozen: 0
  },
  incomeTypes: ['Консультации', 'Услуги'],
  risk: null,
  history: [{
    date: '15.03.2026 23:59',
    action: 'Создан',
    status: 'info'
  }, {
    date: '16.03.2026 10:00',
    action: 'Подготовлен',
    status: 'warning'
  }, {
    date: '16.03.2026 14:30',
    action: 'Выплачен',
    status: 'success'
  }],
  details: ['ORD-1201', 'ORD-1205', 'ORD-1210', 'ORD-1215']
}, {
  id: 'PO-302',
  astrologer: 'Алексей Лунный',
  country: 'DE',
  period: '01–15 марта',
  orders: 18,
  consultations: 5,
  total: 98000,
  commission: 14700,
  refunds: 0,
  payout: 83300,
  status: 'prepared',
  date: '—',
  method: 'PayPal',
  autoPayout: 'weekly',
  balance: {
    available: 83300,
    pending: 15000,
    frozen: 0
  },
  incomeTypes: ['Консультации', 'Курсы'],
  risk: null,
  history: [{
    date: '15.03.2026 23:59',
    action: 'Создан',
    status: 'info'
  }, {
    date: '16.03.2026 10:00',
    action: 'Подготовлен',
    status: 'warning'
  }],
  details: ['ORD-1202', 'ORD-1208']
}, {
  id: 'PO-303',
  astrologer: 'Ольга Солнцева',
  country: 'US',
  period: '01–15 марта',
  orders: 12,
  consultations: 3,
  total: 67000,
  commission: 10050,
  refunds: 8900,
  payout: 48050,
  status: 'hold',
  date: '—',
  method: 'Stripe',
  autoPayout: 'monthly',
  balance: {
    available: 0,
    pending: 12000,
    frozen: 48050
  },
  incomeTypes: ['Консультации'],
  risk: 'жалоба',
  history: [{
    date: '15.03.2026 23:59',
    action: 'Создан',
    status: 'info'
  }, {
    date: '16.03.2026 11:20',
    action: 'Приостановлен (Hold)',
    status: 'error'
  }],
  details: ['ORD-1204', 'ORD-1209']
}, {
  id: 'PO-304',
  astrologer: 'Дмитрий Космос',
  country: 'RU',
  period: '01–15 марта',
  orders: 8,
  consultations: 2,
  total: 45000,
  commission: 6750,
  refunds: 0,
  payout: 38250,
  status: 'frozen',
  date: '—',
  method: 'Crypto',
  autoPayout: 'manual',
  balance: {
    available: 0,
    pending: 0,
    frozen: 38250
  },
  incomeTypes: ['Услуги'],
  risk: 'спор',
  history: [{
    date: '15.03.2026 23:59',
    action: 'Создан',
    status: 'info'
  }, {
    date: '16.03.2026 09:00',
    action: 'Заморожен',
    status: 'error'
  }],
  details: ['ORD-1211']
}];
const mockRefunds = [{
  id: 'REF-101',
  order: 'ORD-1205',
  user: 'Елена Волкова',
  astrologer: 'Мария Звёздная',
  amount: 8900,
  reason: 'Качество отчёта не соответствует ожиданиям, много общих фраз',
  refundType: 'complaint',
  initiator: 'клиент',
  refundMethod: 'Stripe',
  refundFee: 250,
  platformLoss: 1585,
  disputeId: 'DIS-204',
  status: 'reviewing',
  risk: null,
  date: '15.03.2026 14:30',
  consultation: null,
  log: [{
    date: '15.03.2026 14:10',
    action: 'Пользователь открыл спор',
    status: 'warning'
  }, {
    date: '15.03.2026 14:30',
    action: 'Взят в работу администратором',
    status: 'info'
  }]
}, {
  id: 'REF-102',
  order: 'ORD-1198',
  user: 'Пётр Иванов',
  astrologer: 'Алексей Лунный',
  amount: 3500,
  reason: 'Отмена до начала работы (по правилам платформы)',
  refundType: 'auto',
  initiator: 'система',
  refundMethod: 'ЮKassa',
  refundFee: 0,
  platformLoss: 0,
  disputeId: null,
  status: 'completed',
  risk: null,
  date: '14.03.2026 09:15',
  consultation: null,
  log: [{
    date: '14.03.2026 09:10',
    action: 'Автоматический запрос на возврат',
    status: 'info'
  }, {
    date: '14.03.2026 09:15',
    action: 'Деньги отправлены',
    status: 'success'
  }]
}, {
  id: 'REF-103',
  order: 'ORD-1210',
  user: 'Наталья Смирнова',
  astrologer: '—',
  amount: 1990,
  reason: 'Ошибка AI генерации (пустой отчет)',
  refundType: 'manual',
  initiator: 'администратор',
  refundMethod: 'PayPal',
  refundFee: 0,
  platformLoss: 1990,
  disputeId: null,
  status: 'approved',
  risk: null,
  date: '15.03.2026 11:20',
  consultation: null,
  log: [{
    date: '15.03.2026 11:15',
    action: 'Администратор инициировал возврат',
    status: 'info'
  }, {
    date: '15.03.2026 11:20',
    action: 'Возврат подтвержден',
    status: 'success'
  }]
}, {
  id: 'REF-104',
  order: 'ORD-1150',
  user: 'John Doe',
  astrologer: 'Ольга Солнцева',
  amount: 12000,
  reason: 'Chargeback от банка (Fraud)',
  refundType: 'chargeback',
  initiator: 'система',
  refundMethod: 'Stripe',
  refundFee: 1500,
  platformLoss: 13500,
  disputeId: 'DIS-199',
  status: 'completed',
  risk: 'chargeback',
  date: '13.03.2026 16:45',
  consultation: 'CONS-089',
  log: [{
    date: '13.03.2026 16:00',
    action: 'Получен Chargeback',
    status: 'error'
  }, {
    date: '13.03.2026 16:45',
    action: 'Спор проигран, средства списаны',
    status: 'error'
  }]
}, {
  id: 'REF-105',
  order: 'ORD-1222',
  user: 'Анна Каренина',
  astrologer: 'Дмитрий Космос',
  amount: 5000,
  reason: 'Астролог не пришел на консультацию',
  refundType: 'complaint',
  initiator: 'клиент',
  refundMethod: 'Банк',
  refundFee: 50,
  platformLoss: 50,
  disputeId: 'DIS-205',
  status: 'requested',
  risk: 'частые возвраты',
  date: '16.03.2026 08:30',
  consultation: 'CONS-095',
  log: [{
    date: '16.03.2026 08:30',
    action: 'Пользователь запросил возврат',
    status: 'warning'
  }]
}, {
  id: 'REF-106',
  order: 'ORD-1180',
  user: 'Игорь Николаев',
  astrologer: 'Мария Звёздная',
  amount: 4900,
  reason: 'Не согласен с трактовкой натальной карты',
  refundType: 'complaint',
  initiator: 'клиент',
  refundMethod: 'ЮKassa',
  refundFee: 0,
  platformLoss: 0,
  disputeId: 'DIS-201',
  status: 'rejected',
  risk: 'подозрительный',
  date: '12.03.2026 10:00',
  consultation: null,
  log: [{
    date: '11.03.2026 15:00',
    action: 'Пользователь открыл спор',
    status: 'warning'
  }, {
    date: '12.03.2026 10:00',
    action: 'Возврат отклонен (услуга оказана корректно)',
    status: 'error'
  }]
}];
const mockPromos = [{
  id: 'PROMO-01',
  code: 'SPRING2026',
  type: 'Процент',
  discount: '20%',
  restrictions: 'Натальная карта, Совместимость',
  used: 145,
  active: true,
  start: '01.03.2026',
  end: '31.03.2026'
}];
const paymentStatusConfig: Record<string, {
  label: string;
  variant: 'success' | 'warning' | 'error' | 'neutral';
}> = {
  success: {
    label: 'Успешно',
    variant: 'success'
  },
  error: {
    label: 'Ошибка',
    variant: 'error'
  },
  refund: {
    label: 'Возврат',
    variant: 'warning'
  },
  chargeback: {
    label: 'Чарджбэк',
    variant: 'error'
  },
  pending: {
    label: 'Ожидает',
    variant: 'neutral'
  }
};
const payoutStatusConfig: Record<string, {
  label: string;
  variant: 'success' | 'warning' | 'error' | 'neutral' | 'pro';
}> = {
  paid: {
    label: 'Выплачено',
    variant: 'success'
  },
  prepared: {
    label: 'Подготовлено',
    variant: 'pro'
  },
  pending: {
    label: 'Ожидает',
    variant: 'warning'
  },
  frozen: {
    label: 'Заморожено',
    variant: 'error'
  },
  hold: {
    label: 'Hold',
    variant: 'warning'
  },
  cancelled: {
    label: 'Отменено',
    variant: 'error'
  }
};
const refundStatusConfig: Record<string, {
  label: string;
  variant: 'success' | 'warning' | 'error' | 'neutral' | 'pro';
}> = {
  requested: {
    label: 'Запрос',
    variant: 'warning'
  },
  reviewing: {
    label: 'На проверке',
    variant: 'pro'
  },
  approved: {
    label: 'Подтверждён',
    variant: 'success'
  },
  completed: {
    label: 'Выполнен',
    variant: 'success'
  },
  rejected: {
    label: 'Отклонён',
    variant: 'error'
  }
};
const orderTypeConfig: Record<string, {
  color: string;
}> = {
  'AI отчет': {
    color: 'bg-indigo-100 text-indigo-700 border-indigo-200'
  },
  Консультация: {
    color: 'bg-emerald-100 text-emerald-700 border-emerald-200'
  },
  Услуга: {
    color: 'bg-amber-100 text-amber-700 border-amber-200'
  },
  Курс: {
    color: 'bg-purple-100 text-purple-700 border-purple-200'
  }
};
// Format currency
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0
  }).format(amount);
};
export function AdminFinanceFullManager({
  orders,
  users,
  astrologers,
  refunds,
  setActiveTab,
  setDetailPanel,
  success
}: AdminFinanceFullManagerProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [activeKpi, setActiveKpi] = useState<string | null>(null);
  const [selectedPaymentLog, setSelectedPaymentLog] = useState<any | null>(null);
  const [selectedPayoutDetail, setSelectedPayoutDetail] = useState<any | null>(null);
  const [showPayoutFilters, setShowPayoutFilters] = useState(false);
  const [payoutFilters, setPayoutFilters] = useState({
    status: 'all',
    period: 'all',
    astrologer: '',
    country: 'all'
  });
  const [selectedRefundDetail, setSelectedRefundDetail] = useState<any | null>(null);
  const [showRefundFilters, setShowRefundFilters] = useState(false);
  const [refundFilters, setRefundFilters] = useState({
    status: 'all',
    refundType: 'all',
    astrologer: '',
    user: ''
  });
  const [filters, setFilters] = useState({
    status: 'all',
    method: 'all',
    provider: 'all',
    orderType: 'all',
    dateFrom: '',
    dateTo: '',
    minAmount: '',
    maxAmount: '',
    user: '',
    astrologer: ''
  });
  // Apply KPI shortcuts to filters
  const handleKpiClick = (kpi: string) => {
    if (activeKpi === kpi) {
      setActiveKpi(null);
      setFilters({
        ...filters,
        status: 'all'
      });
    } else {
      setActiveKpi(kpi);
      if (kpi === 'errors') {
        setFilters({
          ...filters,
          status: 'error'
        });
      } else if (kpi === 'revenue' || kpi === 'transactions' || kpi === 'commission') {
        // Just visual selection for these, or could set date range to current month
        setFilters({
          ...filters,
          status: 'all'
        });
      }
    }
  };
  const filteredPayments = useMemo(() => {
    return mockPayments.filter(p => {
      // Search
      const matchesSearch = p.id.toLowerCase().includes(searchQuery.toLowerCase()) || p.user.toLowerCase().includes(searchQuery.toLowerCase()) || p.order.toLowerCase().includes(searchQuery.toLowerCase());
      if (!matchesSearch) return false;
      // Filters
      if (filters.status !== 'all' && p.status !== filters.status) return false;
      if (filters.method !== 'all' && !p.method.toLowerCase().includes(filters.method.toLowerCase())) return false;
      if (filters.provider !== 'all' && p.provider !== filters.provider) return false;
      if (filters.orderType !== 'all' && p.orderType !== filters.orderType) return false;
      if (filters.user && !p.user.toLowerCase().includes(filters.user.toLowerCase())) return false;
      if (filters.astrologer && !p.astrologer.toLowerCase().includes(filters.astrologer.toLowerCase())) return false;
      if (filters.minAmount && p.amount < parseInt(filters.minAmount)) return false;
      if (filters.maxAmount && p.amount > parseInt(filters.maxAmount)) return false;
      // Date filtering (simplified for mock)
      if (filters.dateFrom) {
        const pDate = p.date.split(' ')[0].split('.').reverse().join('-');
        if (pDate < filters.dateFrom) return false;
      }
      if (filters.dateTo) {
        const pDate = p.date.split(' ')[0].split('.').reverse().join('-');
        if (pDate > filters.dateTo) return false;
      }
      return true;
    });
  }, [mockPayments, searchQuery, filters]);
  const handleExportPayments = () => {
    const headers = ['Дата', 'Payment ID', 'Заказ', 'Тип', 'Пользователь', 'Астролог', 'Сумма', 'Комиссия', 'Чистый доход', 'Провайдер', 'Метод', 'Страна', 'Статус', 'Причина возврата'];
    const rows = filteredPayments.map(p => [p.date, p.id, p.order, p.orderType, p.user, p.astrologer, p.amount, p.commission, p.netIncome, p.provider, p.method, p.country, paymentStatusConfig[p.status]?.label || p.status, p.refundReason || '']);
    const csvContent = [headers.join(','), ...rows.map(r => r.map((v: any) => `"${String(v).replace(/"/g, '""')}"`).join(','))].join('\n');
    const blob = new Blob(['\uFEFF' + csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `payments_export_${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    success(`Экспорт ${filteredPayments.length} платежей завершён`);
  };
  const renderKpi = (id: string, label: string, value: string | number, icon: React.ReactNode, bg: string, trend?: string) => {
    const isActive = activeKpi === id;
    return <Card padding="sm" hoverable className={`rounded-xl shadow-none border-2 p-4 flex flex-col justify-between h-24 cursor-pointer group transition-all ${isActive ? 'border-indigo-500 bg-indigo-50/30' : 'border-slate-200 hover:border-indigo-300'}`} onClick={() => handleKpiClick(id)} data-id="element-3700">
        <div className={`w-8 h-8 rounded-lg ${bg} flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-3701">
          {icon}
        </div>
        <div data-id="element-3702">
          <div className="text-xs text-slate-500 font-medium mb-0.5" data-id="element-3703">
            {label}
          </div>
          <div className="text-xl font-bold text-slate-900" data-id="element-3704">{value}</div>
          {trend && <div className="text-[10px] text-emerald-600 font-medium" data-id="element-3705">
              {trend}
            </div>}
        </div>
      </Card>;
  };
  const renderRevenueChart = () => {
    // Mock chart data
    const days = ['10.03', '11.03', '12.03', '13.03', '14.03', '15.03', '16.03'];
    const values = [45000, 52000, 48000, 61000, 59000, 82000, 34000];
    const maxVal = Math.max(...values);
    return <Card padding="md" className="rounded-xl shadow-none border-slate-200 mb-6" data-id="element-3706">
        <div className="flex justify-between items-center mb-6" data-id="element-3707">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-3708">
            <BarChart3 className="w-4 h-4 text-indigo-600" data-id="element-3709" /> Выручка по дням
            (последние 7 дней)
          </h3>
          <div className="text-sm font-bold text-emerald-600" data-id="element-3710">
            Всего: ₽381,000
          </div>
        </div>
        <div className="flex items-end gap-2 h-40" data-id="element-3711">
          {values.map((v, i) => <div key={i} className="flex-1 flex flex-col items-center gap-2 group relative" data-id="element-3712">
              {/* Tooltip */}
              <div className="absolute -top-8 bg-slate-800 text-white text-[10px] py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-10" data-id="element-3713">
                {formatCurrency(v)}
              </div>
              <div className="w-full bg-indigo-100 group-hover:bg-indigo-200 rounded-t transition-colors relative overflow-hidden" style={{
            height: '100%'
          }} data-id="element-3714">
                <div className="absolute bottom-0 left-0 right-0 bg-indigo-500 group-hover:bg-indigo-600 transition-colors rounded-t" style={{
              height: `${v / maxVal * 100}%`
            }} data-id="element-3715" />
              </div>
              <span className="text-[10px] text-slate-400 font-medium" data-id="element-3716">
                {days[i]}
              </span>
            </div>)}
        </div>
      </Card>;
  };
  const renderPayments = () => <div className="space-y-4" data-id="element-3717">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-id="element-3718">
        {renderKpi('revenue', 'Выручка (мес)', '₽2.4M', <DollarSign className="w-4 h-4 text-emerald-600" data-id="element-3719" />, 'bg-emerald-50', '+18%')}
        {renderKpi('transactions', 'Транзакций', '1,247', <CreditCard className="w-4 h-4 text-blue-600" data-id="element-3720" />, 'bg-blue-50')}
        {renderKpi('commission', 'Доход платформы', '₽360K', <ArrowUpRight className="w-4 h-4 text-indigo-600" data-id="element-3721" />, 'bg-indigo-50')}
        {renderKpi('errors', 'Ошибки / Возвраты', '12', <AlertTriangle className="w-4 h-4 text-rose-600" data-id="element-3722" />, 'bg-rose-50')}
      </div>

      {renderRevenueChart()}

      <Card padding="sm" className="rounded-xl shadow-none border-slate-200" data-id="element-3723">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3" data-id="element-3724">
          <div className="relative flex-1 max-w-md" data-id="element-3725">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-3726" />
            <input type="text" placeholder="Поиск по ID, пользователю, заказу..." className="w-full pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3727" />
          </div>
          <div className="flex gap-2" data-id="element-3728">
            <Button variant={showFilters ? 'primary' : 'outline'} size="sm" icon={<Search className="w-4 h-4" data-id="element-3730" />} onClick={() => setShowFilters(!showFilters)} data-id="element-3729">
              Фильтры
            </Button>
            <Button variant="outline" size="sm" icon={<FileSpreadsheet className="w-4 h-4" data-id="element-3732" />} onClick={handleExportPayments} data-id="element-3731">
              Экспорт CSV
            </Button>
          </div>
        </div>

        {/* Advanced Filters Panel */}
        {showFilters && <div className="mt-4 pt-4 border-t border-slate-100 space-y-4 animate-in slide-in-from-top-2" data-id="element-3733">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-3734">
              <div data-id="element-3735">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3736">
                  Статус
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={filters.status} onChange={e => setFilters({
              ...filters,
              status: e.target.value
            })} data-id="element-3737">
                  <option value="all" data-id="element-3738">Все</option>
                  <option value="success" data-id="element-3739">Успешно</option>
                  <option value="error" data-id="element-3740">Ошибка</option>
                  <option value="refund" data-id="element-3741">Возврат</option>
                  <option value="chargeback" data-id="element-3742">Чарджбэк</option>
                </select>
              </div>
              <div data-id="element-3743">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3744">
                  Тип заказа
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={filters.orderType} onChange={e => setFilters({
              ...filters,
              orderType: e.target.value
            })} data-id="element-3745">
                  <option value="all" data-id="element-3746">Все</option>
                  <option value="AI отчет" data-id="element-3747">AI отчет</option>
                  <option value="Консультация" data-id="element-3748">Консультация</option>
                  <option value="Услуга" data-id="element-3749">Услуга</option>
                  <option value="Курс" data-id="element-3750">Курс</option>
                </select>
              </div>
              <div data-id="element-3751">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3752">
                  Провайдер
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={filters.provider} onChange={e => setFilters({
              ...filters,
              provider: e.target.value
            })} data-id="element-3753">
                  <option value="all" data-id="element-3754">Все</option>
                  <option value="Stripe" data-id="element-3755">Stripe</option>
                  <option value="PayPal" data-id="element-3756">PayPal</option>
                  <option value="ЮKassa" data-id="element-3757">ЮKassa</option>
                </select>
              </div>
              <div data-id="element-3758">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3759">
                  Метод оплаты
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={filters.method} onChange={e => setFilters({
              ...filters,
              method: e.target.value
            })} data-id="element-3760">
                  <option value="all" data-id="element-3761">Все</option>
                  <option value="visa" data-id="element-3762">Visa / Mastercard</option>
                  <option value="mir" data-id="element-3763">Mir</option>
                  <option value="apple" data-id="element-3764">Apple Pay</option>
                  <option value="paypal" data-id="element-3765">PayPal</option>
                </select>
              </div>

              <div data-id="element-3766">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3767">
                  Дата от
                </label>
                <input type="date" className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={filters.dateFrom} onChange={e => setFilters({
              ...filters,
              dateFrom: e.target.value
            })} data-id="element-3768" />
              </div>
              <div data-id="element-3769">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3770">
                  Дата до
                </label>
                <input type="date" className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={filters.dateTo} onChange={e => setFilters({
              ...filters,
              dateTo: e.target.value
            })} data-id="element-3771" />
              </div>
              <div data-id="element-3772">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3773">
                  Пользователь
                </label>
                <input type="text" placeholder="Имя..." className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={filters.user} onChange={e => setFilters({
              ...filters,
              user: e.target.value
            })} data-id="element-3774" />
              </div>
              <div data-id="element-3775">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3776">
                  Астролог
                </label>
                <input type="text" placeholder="Имя..." className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={filters.astrologer} onChange={e => setFilters({
              ...filters,
              astrologer: e.target.value
            })} data-id="element-3777" />
              </div>
            </div>
            <div className="flex justify-end pt-2" data-id="element-3778">
              <Button variant="ghost" size="sm" onClick={() => setFilters({
            status: 'all',
            method: 'all',
            provider: 'all',
            orderType: 'all',
            dateFrom: '',
            dateTo: '',
            minAmount: '',
            maxAmount: '',
            user: '',
            astrologer: ''
          })} data-id="element-3779">
                Сбросить фильтры
              </Button>
            </div>
          </div>}
      </Card>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-3780">
        <div className="overflow-x-auto" data-id="element-3781">
          <table className="w-full text-left whitespace-nowrap" data-id="element-3782">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[10px] uppercase tracking-wider" data-id="element-3783">
              <tr data-id="element-3784">
                <th className="px-4 py-3 font-medium" data-id="element-3785">Дата / ID</th>
                <th className="px-4 py-3 font-medium" data-id="element-3786">Заказ / Тип</th>
                <th className="px-4 py-3 font-medium" data-id="element-3787">Клиент / Астролог</th>
                <th className="px-4 py-3 font-medium" data-id="element-3788">Провайдер / Метод</th>
                <th className="px-4 py-3 font-medium" data-id="element-3789">Сумма / Доход</th>
                <th className="px-4 py-3 font-medium" data-id="element-3790">Статус / Риск</th>
                <th className="px-4 py-3 text-right font-medium" data-id="element-3791">Действия</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-3792">
              {filteredPayments.map(p => <tr key={p.id} className="hover:bg-slate-50 transition-colors group" data-id="element-3793">
                  <td className="px-4 py-3" data-id="element-3794">
                    <div className="flex items-center gap-1.5 text-xs text-slate-600 mb-1" data-id="element-3795">
                      <Calendar className="w-3 h-3" data-id="element-3796" /> {p.date}
                    </div>
                    <div className="text-[11px] font-bold text-indigo-600 font-mono" data-id="element-3797">
                      {p.id}
                    </div>
                  </td>

                  <td className="px-4 py-3" data-id="element-3798">
                    <div className="flex items-center gap-1 text-xs font-bold text-slate-900 cursor-pointer hover:text-indigo-600 mb-1" onClick={() => setDetailPanel({
                  type: 'order_full',
                  title: `Заказ ${p.order}`,
                  data: {
                    id: p.order
                  }
                })} data-id="element-3799">
                      {p.order}{' '}
                      <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-3800" />
                    </div>
                    <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-medium border ${orderTypeConfig[p.orderType]?.color || 'bg-slate-100 text-slate-700 border-slate-200'}`} data-id="element-3801">
                      {p.orderType}
                    </span>
                  </td>

                  <td className="px-4 py-3" data-id="element-3802">
                    <div className="flex items-center gap-1.5 text-xs font-medium text-slate-900 cursor-pointer hover:text-indigo-600 mb-1" onClick={() => setDetailPanel({
                  type: 'user_profile',
                  title: `Пользователь`,
                  data: {
                    name: p.user
                  }
                })} data-id="element-3803">
                      <UserIcon className="w-3 h-3 text-slate-400" data-id="element-3804" /> {p.user}
                    </div>
                    {p.astrologer !== '—' ? <div className="flex items-center gap-1.5 text-[11px] text-slate-600 cursor-pointer hover:text-indigo-600" onClick={() => setActiveTab('astrologers')} data-id="element-3805">
                        <StarIcon className="w-3 h-3 text-amber-400" data-id="element-3806" />{' '}
                        {p.astrologer}
                      </div> : <div className="text-[11px] text-slate-400" data-id="element-3807">—</div>}
                  </td>

                  <td className="px-4 py-3" data-id="element-3808">
                    <div className="flex items-center gap-1.5 text-xs font-medium text-slate-800 mb-1" data-id="element-3809">
                      <Banknote className="w-3 h-3 text-emerald-500" data-id="element-3810" />{' '}
                      {p.provider}
                    </div>
                    <div className="flex items-center gap-2 text-[10px] text-slate-500" data-id="element-3811">
                      <span data-id="element-3812">{p.method}</span>
                      <span className="flex items-center gap-0.5" data-id="element-3813">
                        <Globe className="w-3 h-3" data-id="element-3814" /> {p.country}
                      </span>
                    </div>
                  </td>

                  <td className="px-4 py-3" data-id="element-3815">
                    <div className="text-sm font-bold text-slate-900 mb-0.5" data-id="element-3816">
                      {formatCurrency(p.amount)}
                    </div>
                    <div className="flex items-center gap-2 text-[10px]" data-id="element-3817">
                      <span className="text-slate-500" title="Комиссия астролога/партнера" data-id="element-3818">
                        Ком: {formatCurrency(p.commission)}
                      </span>
                      <span className={`font-bold ${p.netIncome > 0 ? 'text-emerald-600' : p.netIncome < 0 ? 'text-rose-600' : 'text-slate-400'}`} title="Чистый доход платформы" data-id="element-3819">
                        Платф: {formatCurrency(p.netIncome)}
                      </span>
                    </div>
                  </td>

                  <td className="px-4 py-3" data-id="element-3820">
                    <div className="mb-1.5" data-id="element-3821">
                      <Badge variant={paymentStatusConfig[p.status]?.variant || 'neutral'} size="sm" className="text-[10px]" data-id="element-3822">
                        {paymentStatusConfig[p.status]?.label || p.status}
                      </Badge>
                    </div>
                    {p.risk && <div className="flex items-center gap-1 text-[10px] font-medium text-rose-600 bg-rose-50 px-1.5 py-0.5 rounded inline-flex" data-id="element-3823">
                        <AlertTriangle className="w-3 h-3" data-id="element-3824" /> {p.risk}
                      </div>}
                    {p.refundReason && <div className="text-[9px] text-slate-500 mt-0.5 max-w-[120px] truncate" title={p.refundReason} data-id="element-3825">
                        {p.refundReason}
                      </div>}
                  </td>

                  <td className="px-4 py-3 text-right" data-id="element-3826">
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50" icon={<History className="w-4 h-4" data-id="element-3828" />} onClick={() => setSelectedPaymentLog(p)} title="Финансовый лог" data-id="element-3827" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Financial Log Modal */}
      {selectedPaymentLog && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" onClick={e => {
      if (e.target === e.currentTarget) setSelectedPaymentLog(null);
    }} data-id="element-3829">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-in zoom-in-95" data-id="element-3830">
            <div className="flex items-center justify-between p-4 border-b border-slate-100 bg-slate-50" data-id="element-3831">
              <div className="flex items-center gap-2" data-id="element-3832">
                <Receipt className="w-5 h-5 text-indigo-600" data-id="element-3833" />
                <h3 className="font-bold text-slate-900" data-id="element-3834">
                  Финансовый лог {selectedPaymentLog.id}
                </h3>
              </div>
              <button onClick={() => setSelectedPaymentLog(null)} className="p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-200" data-id="element-3835">
                <X className="w-5 h-5" data-id="element-3836" />
              </button>
            </div>

            <div className="p-5 bg-slate-50/50 border-b border-slate-100 flex justify-between items-center" data-id="element-3837">
              <div data-id="element-3838">
                <div className="text-xs text-slate-500 mb-1" data-id="element-3839">Сумма платежа</div>
                <div className="text-xl font-bold text-slate-900" data-id="element-3840">
                  {formatCurrency(selectedPaymentLog.amount)}
                </div>
              </div>
              <div className="text-right" data-id="element-3841">
                <div className="text-xs text-slate-500 mb-1" data-id="element-3842">Провайдер</div>
                <div className="text-sm font-medium text-slate-900" data-id="element-3843">
                  {selectedPaymentLog.provider} ({selectedPaymentLog.method})
                </div>
              </div>
            </div>

            <div className="p-6" data-id="element-3844">
              <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-4" data-id="element-3845">
                История транзакции
              </h4>
              <div className="space-y-4 relative before:absolute before:inset-0 before:ml-2.5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-200 before:to-transparent" data-id="element-3846">
                {selectedPaymentLog.log.map((event: any, idx: number) => <div key={idx} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-3847">
                    <div className="flex items-center justify-center w-5 h-5 rounded-full border-2 border-white bg-slate-200 text-slate-500 shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-3848">
                      {event.status === 'success' ? <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-3849" /> : event.status === 'error' ? <XCircle className="w-3 h-3 text-rose-500" data-id="element-3850" /> : event.status === 'refund' ? <ArrowDownRight className="w-3 h-3 text-amber-500" data-id="element-3851" /> : <Clock className="w-3 h-3 text-slate-400" data-id="element-3852" />}
                    </div>
                    <div className="w-[calc(100%-2rem)] md:w-[calc(50%-1.5rem)] p-3 rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-3853">
                      <div className="flex items-center justify-between mb-1" data-id="element-3854">
                        <div className={`font-bold text-xs ${event.status === 'success' ? 'text-emerald-700' : event.status === 'error' ? 'text-rose-700' : event.status === 'refund' ? 'text-amber-700' : 'text-slate-700'}`} data-id="element-3855">
                          {event.action}
                        </div>
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-3856">
                        {event.date}
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
            <div className="p-4 border-t border-slate-100 flex justify-end bg-slate-50" data-id="element-3857">
              <Button variant="outline" onClick={() => setSelectedPaymentLog(null)} data-id="element-3858">
                Закрыть
              </Button>
            </div>
          </div>
        </div>}
    </div>;
  const renderPayouts = () => {
    const filteredPayouts = mockPayouts.filter(p => {
      if (payoutFilters.status !== 'all' && p.status !== payoutFilters.status) return false;
      if (payoutFilters.country !== 'all' && p.country !== payoutFilters.country) return false;
      if (payoutFilters.astrologer && !p.astrologer.toLowerCase().includes(payoutFilters.astrologer.toLowerCase())) return false;
      return true;
    });
    return <div className="space-y-4" data-id="element-3859">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-id="element-3860">
          {renderKpi('p1', 'К выплате', '₽299,200', <ArrowDownRight className="w-4 h-4 text-amber-600" data-id="element-3861" />, 'bg-amber-50')}
          {renderKpi('p2', 'Выплачено (мес)', '₽1.8M', <CheckCircle2 className="w-4 h-4 text-emerald-600" data-id="element-3862" />, 'bg-emerald-50')}
          {renderKpi('p3', 'Заморожено / Hold', '₽86,300', <PauseCircle className="w-4 h-4 text-rose-600" data-id="element-3863" />, 'bg-rose-50')}
          {renderKpi('p4', 'Астрологов', astrologers.length, <UserIcon className="w-4 h-4 text-indigo-600" data-id="element-3864" />, 'bg-indigo-50')}
        </div>

        <Card padding="sm" className="rounded-xl shadow-none border-slate-200" data-id="element-3865">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3" data-id="element-3866">
            <div className="flex gap-2" data-id="element-3867">
              <Button variant={showPayoutFilters ? 'primary' : 'outline'} size="sm" icon={<Search className="w-4 h-4" data-id="element-3869" />} onClick={() => setShowPayoutFilters(!showPayoutFilters)} data-id="element-3868">
                Фильтры
              </Button>
              <Button variant="outline" size="sm" icon={<DownloadCloud className="w-4 h-4" data-id="element-3871" />} onClick={() => success('Отчет по выплатам скачан')} data-id="element-3870">
                Скачать отчёт
              </Button>
            </div>
          </div>

          {showPayoutFilters && <div className="mt-4 pt-4 border-t border-slate-100 space-y-4 animate-in slide-in-from-top-2" data-id="element-3872">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-3873">
                <div data-id="element-3874">
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3875">
                    Статус
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={payoutFilters.status} onChange={e => setPayoutFilters({
                ...payoutFilters,
                status: e.target.value
              })} data-id="element-3876">
                    <option value="all" data-id="element-3877">Все</option>
                    <option value="paid" data-id="element-3878">Выплачено</option>
                    <option value="prepared" data-id="element-3879">Подготовлено</option>
                    <option value="hold" data-id="element-3880">Hold</option>
                    <option value="frozen" data-id="element-3881">Заморожено</option>
                  </select>
                </div>
                <div data-id="element-3882">
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3883">
                    Страна
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={payoutFilters.country} onChange={e => setPayoutFilters({
                ...payoutFilters,
                country: e.target.value
              })} data-id="element-3884">
                    <option value="all" data-id="element-3885">Все</option>
                    <option value="RU" data-id="element-3886">RU</option>
                    <option value="DE" data-id="element-3887">DE</option>
                    <option value="US" data-id="element-3888">US</option>
                  </select>
                </div>
                <div data-id="element-3889">
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-3890">
                    Астролог
                  </label>
                  <input type="text" placeholder="Имя..." className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={payoutFilters.astrologer} onChange={e => setPayoutFilters({
                ...payoutFilters,
                astrologer: e.target.value
              })} data-id="element-3891" />
                </div>
              </div>
            </div>}
        </Card>

        <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-3892">
          <div className="overflow-x-auto" data-id="element-3893">
            <table className="w-full text-left whitespace-nowrap" data-id="element-3894">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[10px] uppercase tracking-wider" data-id="element-3895">
                <tr data-id="element-3896">
                  <th className="px-4 py-3 font-medium" data-id="element-3897">ID / Период</th>
                  <th className="px-4 py-3 font-medium" data-id="element-3898">Астролог / Страна</th>
                  <th className="px-4 py-3 font-medium" data-id="element-3899">Метод / Авто</th>
                  <th className="px-4 py-3 font-medium" data-id="element-3900">Сумма / Возвраты</th>
                  <th className="px-4 py-3 font-medium" data-id="element-3901">Баланс</th>
                  <th className="px-4 py-3 font-medium" data-id="element-3902">Статус / Риск</th>
                  <th className="px-4 py-3 text-right font-medium" data-id="element-3903">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-3904">
                {filteredPayouts.map(p => <tr key={p.id} className="hover:bg-slate-50 transition-colors group" data-id="element-3905">
                    <td className="px-4 py-3" data-id="element-3906">
                      <div className="text-[11px] font-bold text-indigo-600 font-mono mb-1" data-id="element-3907">
                        {p.id}
                      </div>
                      <div className="flex items-center gap-1.5 text-xs text-slate-500" data-id="element-3908">
                        <Calendar className="w-3 h-3" data-id="element-3909" /> {p.period}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-3910">
                      <div className="flex items-center gap-1.5 text-sm font-medium text-slate-900 cursor-pointer hover:text-indigo-600 mb-1" onClick={() => setActiveTab('astrologers')} data-id="element-3911">
                        <UserIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-3912" />{' '}
                        {p.astrologer}
                      </div>
                      <div className="flex items-center gap-2 text-[10px] text-slate-500" data-id="element-3913">
                        <span className="flex items-center gap-0.5" data-id="element-3914">
                          <Globe className="w-3 h-3" data-id="element-3915" /> {p.country}
                        </span>
                        <span className="text-slate-300" data-id="element-3916">|</span>
                        <span data-id="element-3917">{p.incomeTypes.join(', ')}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-3918">
                      <div className="flex items-center gap-1.5 text-xs font-medium text-slate-800 mb-1" data-id="element-3919">
                        <Wallet className="w-3 h-3 text-indigo-500" data-id="element-3920" />{' '}
                        {p.method}
                      </div>
                      <div className="flex items-center gap-1 text-[10px] text-slate-500" data-id="element-3921">
                        <Repeat className="w-3 h-3" data-id="element-3922" />{' '}
                        {p.autoPayout === 'monthly' ? 'Ежемесячно' : p.autoPayout === 'weekly' ? 'Еженедельно' : 'Вручную'}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-3923">
                      <div className="text-sm font-bold text-slate-900 mb-0.5" data-id="element-3924">
                        {formatCurrency(p.payout)}
                      </div>
                      <div className="flex items-center gap-2 text-[10px]" data-id="element-3925">
                        <span className="text-slate-500" title="Общая сумма" data-id="element-3926">
                          Всего: {formatCurrency(p.total)}
                        </span>
                        {p.refunds > 0 && <span className="text-rose-600 font-medium" title="Возвраты" data-id="element-3927">
                            Возвраты: -{formatCurrency(p.refunds)}
                          </span>}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-3928">
                      <div className="flex flex-col gap-1 text-[10px]" data-id="element-3929">
                        <div className="flex justify-between gap-2" data-id="element-3930">
                          <span className="text-slate-500" data-id="element-3931">Доступно:</span>{' '}
                          <span className="font-medium text-emerald-600" data-id="element-3932">
                            {formatCurrency(p.balance.available)}
                          </span>
                        </div>
                        <div className="flex justify-between gap-2" data-id="element-3933">
                          <span className="text-slate-500" data-id="element-3934">В ожидании:</span>{' '}
                          <span className="font-medium text-amber-600" data-id="element-3935">
                            {formatCurrency(p.balance.pending)}
                          </span>
                        </div>
                        {p.balance.frozen > 0 && <div className="flex justify-between gap-2" data-id="element-3936">
                            <span className="text-slate-500" data-id="element-3937">Заморожено:</span>{' '}
                            <span className="font-medium text-rose-600" data-id="element-3938">
                              {formatCurrency(p.balance.frozen)}
                            </span>
                          </div>}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-3939">
                      <div className="mb-1.5" data-id="element-3940">
                        <Badge variant={payoutStatusConfig[p.status]?.variant || 'neutral'} size="sm" className="text-[10px]" data-id="element-3941">
                          {payoutStatusConfig[p.status]?.label || p.status}
                        </Badge>
                        {p.date !== '—' && <span className="ml-2 text-[10px] text-slate-500" data-id="element-3942">
                            {p.date}
                          </span>}
                      </div>
                      {p.risk && <div className="flex items-center gap-1 text-[10px] font-medium text-rose-600 bg-rose-50 px-1.5 py-0.5 rounded inline-flex" data-id="element-3943">
                          <AlertTriangle className="w-3 h-3" data-id="element-3944" /> {p.risk}
                        </div>}
                    </td>
                    <td className="px-4 py-3 text-right" data-id="element-3945">
                      <div className="flex items-center justify-end gap-1" data-id="element-3946">
                        {p.status === 'prepared' && <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-emerald-600 hover:bg-emerald-50" icon={<CheckCircle2 className="w-3.5 h-3.5" data-id="element-3948" />} onClick={() => success(`Выплата ${p.id} отправлена`)} title="Выплатить" data-id="element-3947" />}
                        <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<RefreshCw className="w-3.5 h-3.5" data-id="element-3950" />} onClick={() => success(`Выплата ${p.id} пересчитана`)} title="Пересчитать" data-id="element-3949" />
                        <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<ListOrdered className="w-3.5 h-3.5" data-id="element-3952" />} onClick={() => setSelectedPayoutDetail(p)} title="Детализация" data-id="element-3951" />
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Payout Detail Modal */}
        {selectedPayoutDetail && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" onClick={e => {
        if (e.target === e.currentTarget) setSelectedPayoutDetail(null);
      }} data-id="element-3953">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in zoom-in-95 flex flex-col max-h-[90vh]" data-id="element-3954">
              <div className="flex items-center justify-between p-4 border-b border-slate-100 bg-slate-50 shrink-0" data-id="element-3955">
                <div className="flex items-center gap-2" data-id="element-3956">
                  <Wallet className="w-5 h-5 text-indigo-600" data-id="element-3957" />
                  <h3 className="font-bold text-slate-900" data-id="element-3958">
                    Детализация выплаты {selectedPayoutDetail.id}
                  </h3>
                  <Badge variant={payoutStatusConfig[selectedPayoutDetail.status]?.variant || 'neutral'} size="sm" data-id="element-3959">
                    {payoutStatusConfig[selectedPayoutDetail.status]?.label}
                  </Badge>
                </div>
                <button onClick={() => setSelectedPayoutDetail(null)} className="p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-200" data-id="element-3960">
                  <X className="w-5 h-5" data-id="element-3961" />
                </button>
              </div>

              <div className="overflow-y-auto p-6 space-y-6" data-id="element-3962">
                <div className="grid grid-cols-3 gap-4" data-id="element-3963">
                  <div className="p-4 rounded-xl bg-slate-50 border border-slate-100" data-id="element-3964">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-3965">
                      Сумма к выплате
                    </div>
                    <div className="text-xl font-bold text-emerald-600" data-id="element-3966">
                      {formatCurrency(selectedPayoutDetail.payout)}
                    </div>
                  </div>
                  <div className="p-4 rounded-xl bg-slate-50 border border-slate-100" data-id="element-3967">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-3968">Возвраты</div>
                    <div className="text-xl font-bold text-rose-600" data-id="element-3969">
                      {formatCurrency(selectedPayoutDetail.refunds)}
                    </div>
                  </div>
                  <div className="p-4 rounded-xl bg-slate-50 border border-slate-100" data-id="element-3970">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-3971">
                      Комиссия платформы
                    </div>
                    <div className="text-xl font-bold text-indigo-600" data-id="element-3972">
                      {formatCurrency(selectedPayoutDetail.commission)}
                    </div>
                  </div>
                </div>

                <div data-id="element-3973">
                  <h4 className="text-sm font-bold text-slate-900 mb-3 flex items-center gap-2" data-id="element-3974">
                    <ListOrdered className="w-4 h-4 text-slate-400" data-id="element-3975" /> Заказы в
                    выплате ({selectedPayoutDetail.details.length})
                  </h4>
                  <div className="flex flex-wrap gap-2" data-id="element-3976">
                    {selectedPayoutDetail.details.map((orderId: string) => <div key={orderId} className="px-3 py-1.5 rounded-lg border border-slate-200 bg-white text-xs font-medium text-indigo-600 cursor-pointer hover:border-indigo-300 hover:bg-indigo-50 transition-colors flex items-center gap-1" onClick={() => {
                  setSelectedPayoutDetail(null);
                  setDetailPanel({
                    type: 'order_full',
                    title: `Заказ ${orderId}`,
                    data: {
                      id: orderId
                    }
                  });
                }} data-id="element-3977">
                        {orderId} <ExternalLink className="w-3 h-3" data-id="element-3978" />
                      </div>)}
                  </div>
                </div>

                <div data-id="element-3979">
                  <h4 className="text-sm font-bold text-slate-900 mb-3 flex items-center gap-2" data-id="element-3980">
                    <History className="w-4 h-4 text-slate-400" data-id="element-3981" /> История
                    выплаты
                  </h4>
                  <div className="space-y-4 relative before:absolute before:inset-0 before:ml-2.5 before:-translate-x-px before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-200 before:to-transparent" data-id="element-3982">
                    {selectedPayoutDetail.history.map((event: any, idx: number) => <div key={idx} className="relative flex items-center gap-4 group is-active" data-id="element-3983">
                          <div className="flex items-center justify-center w-5 h-5 rounded-full border-2 border-white bg-slate-200 text-slate-500 shadow shrink-0 z-10" data-id="element-3984">
                            {event.status === 'success' ? <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-3985" /> : event.status === 'error' ? <XCircle className="w-3 h-3 text-rose-500" data-id="element-3986" /> : event.status === 'warning' ? <Clock className="w-3 h-3 text-amber-500" data-id="element-3987" /> : <Info className="w-3 h-3 text-slate-400" data-id="element-3988" />}
                          </div>
                          <div className="flex-1 p-3 rounded-lg border border-slate-200 bg-white shadow-sm flex justify-between items-center" data-id="element-3989">
                            <div className={`font-bold text-xs ${event.status === 'success' ? 'text-emerald-700' : event.status === 'error' ? 'text-rose-700' : event.status === 'warning' ? 'text-amber-700' : 'text-slate-700'}`} data-id="element-3990">
                              {event.action}
                            </div>
                            <div className="text-[10px] text-slate-500" data-id="element-3991">
                              {event.date}
                            </div>
                          </div>
                        </div>)}
                  </div>
                </div>
              </div>

              <div className="p-4 border-t border-slate-100 flex justify-between items-center bg-slate-50 shrink-0" data-id="element-3992">
                <div className="flex gap-2" data-id="element-3993">
                  <Button variant="outline" size="sm" icon={<RefreshCw className="w-4 h-4" data-id="element-3995" />} onClick={() => success('Выплата пересчитана')} data-id="element-3994">
                    Пересчитать
                  </Button>
                  {selectedPayoutDetail.status !== 'hold' && selectedPayoutDetail.status !== 'frozen' && <Button variant="outline" size="sm" className="text-amber-600 hover:bg-amber-50 hover:border-amber-200" icon={<PauseCircle className="w-4 h-4" data-id="element-3997" />} onClick={() => success('Выплата переведена в Hold')} data-id="element-3996">
                        Hold
                      </Button>}
                </div>
                <div className="flex gap-2" data-id="element-3998">
                  <Button variant="outline" onClick={() => setSelectedPayoutDetail(null)} data-id="element-3999">
                    Закрыть
                  </Button>
                  {selectedPayoutDetail.status === 'prepared' && <Button variant="primary" icon={<CheckCircle2 className="w-4 h-4" data-id="element-4001" />} onClick={() => {
                success('Выплата отправлена');
                setSelectedPayoutDetail(null);
              }} data-id="element-4000">
                      Выплатить
                    </Button>}
                </div>
              </div>
            </div>
          </div>}
      </div>;
  };
  const renderRefunds = () => {
    const filteredRefunds = mockRefunds.filter(r => {
      if (refundFilters.status !== 'all' && r.status !== refundFilters.status) return false;
      if (refundFilters.refundType !== 'all' && r.refundType !== refundFilters.refundType) return false;
      if (refundFilters.astrologer && !r.astrologer.toLowerCase().includes(refundFilters.astrologer.toLowerCase())) return false;
      if (refundFilters.user && !r.user.toLowerCase().includes(refundFilters.user.toLowerCase())) return false;
      return true;
    });
    return <div className="space-y-4" data-id="element-4002">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-id="element-4003">
          {renderKpi('r1', 'Всего возвратов', '₽120,000', <ArrowDownRight className="w-4 h-4 text-rose-600" data-id="element-4004" />, 'bg-rose-50')}
          {renderKpi('r2', 'Возвраты сегодня', '₽14,500', <Clock className="w-4 h-4 text-amber-600" data-id="element-4005" />, 'bg-amber-50')}
          {renderKpi('r3', 'По жалобам', '18', <MessageSquare className="w-4 h-4 text-indigo-600" data-id="element-4006" />, 'bg-indigo-50')}
          {renderKpi('r4', 'Chargeback', '3', <AlertTriangle className="w-4 h-4 text-rose-600" data-id="element-4007" />, 'bg-rose-50')}
        </div>

        <Card padding="sm" className="rounded-xl shadow-none border-slate-200" data-id="element-4008">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3" data-id="element-4009">
            <div className="flex gap-2" data-id="element-4010">
              <Button variant={showRefundFilters ? 'primary' : 'outline'} size="sm" icon={<Search className="w-4 h-4" data-id="element-4012" />} onClick={() => setShowRefundFilters(!showRefundFilters)} data-id="element-4011">
                Фильтры
              </Button>
              <Button variant="outline" size="sm" icon={<DownloadCloud className="w-4 h-4" data-id="element-4014" />} onClick={() => success('Отчет по возвратам скачан')} data-id="element-4013">
                Скачать отчёт
              </Button>
            </div>
          </div>

          {showRefundFilters && <div className="mt-4 pt-4 border-t border-slate-100 space-y-4 animate-in slide-in-from-top-2" data-id="element-4015">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4016">
                <div data-id="element-4017">
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-4018">
                    Статус
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={refundFilters.status} onChange={e => setRefundFilters({
                ...refundFilters,
                status: e.target.value
              })} data-id="element-4019">
                    <option value="all" data-id="element-4020">Все</option>
                    <option value="requested" data-id="element-4021">Запрос</option>
                    <option value="reviewing" data-id="element-4022">На проверке</option>
                    <option value="approved" data-id="element-4023">Подтверждён</option>
                    <option value="completed" data-id="element-4024">Выполнен</option>
                    <option value="rejected" data-id="element-4025">Отклонён</option>
                  </select>
                </div>
                <div data-id="element-4026">
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-4027">
                    Тип возврата
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={refundFilters.refundType} onChange={e => setRefundFilters({
                ...refundFilters,
                refundType: e.target.value
              })} data-id="element-4028">
                    <option value="all" data-id="element-4029">Все</option>
                    <option value="auto" data-id="element-4030">Автоматический</option>
                    <option value="complaint" data-id="element-4031">По жалобе</option>
                    <option value="manual" data-id="element-4032">Ручной</option>
                    <option value="chargeback" data-id="element-4033">Chargeback</option>
                  </select>
                </div>
                <div data-id="element-4034">
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-4035">
                    Пользователь
                  </label>
                  <input type="text" placeholder="Имя..." className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={refundFilters.user} onChange={e => setRefundFilters({
                ...refundFilters,
                user: e.target.value
              })} data-id="element-4036" />
                </div>
                <div data-id="element-4037">
                  <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-4038">
                    Астролог
                  </label>
                  <input type="text" placeholder="Имя..." className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3 focus:ring-1 focus:ring-indigo-500" value={refundFilters.astrologer} onChange={e => setRefundFilters({
                ...refundFilters,
                astrologer: e.target.value
              })} data-id="element-4039" />
                </div>
              </div>
            </div>}
        </Card>

        <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-4040">
          <div className="overflow-x-auto" data-id="element-4041">
            <table className="w-full text-left whitespace-nowrap" data-id="element-4042">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[10px] uppercase tracking-wider" data-id="element-4043">
                <tr data-id="element-4044">
                  <th className="px-4 py-3 font-medium" data-id="element-4045">ID / Дата</th>
                  <th className="px-4 py-3 font-medium" data-id="element-4046">Тип / Инициатор</th>
                  <th className="px-4 py-3 font-medium" data-id="element-4047">Заказ / Спор</th>
                  <th className="px-4 py-3 font-medium" data-id="element-4048">Клиент / Астролог</th>
                  <th className="px-4 py-3 font-medium" data-id="element-4049">Сумма / Потери</th>
                  <th className="px-4 py-3 font-medium" data-id="element-4050">Статус / Риск</th>
                  <th className="px-4 py-3 text-right font-medium" data-id="element-4051">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-4052">
                {filteredRefunds.map(r => <tr key={r.id} className="hover:bg-slate-50 transition-colors group" data-id="element-4053">
                    <td className="px-4 py-3" data-id="element-4054">
                      <div className="text-[11px] font-bold text-rose-600 font-mono mb-1" data-id="element-4055">
                        {r.id}
                      </div>
                      <div className="flex items-center gap-1.5 text-xs text-slate-500" data-id="element-4056">
                        <Calendar className="w-3 h-3" data-id="element-4057" /> {r.date.split(' ')[0]}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-4058">
                      <div className="flex items-center gap-1.5 text-xs font-medium text-slate-800 mb-1" data-id="element-4059">
                        {r.refundType === 'auto' ? 'Автоматический' : r.refundType === 'complaint' ? 'По жалобе' : r.refundType === 'manual' ? 'Ручной' : 'Chargeback'}
                      </div>
                      <div className="flex items-center gap-1 text-[10px] text-slate-500" data-id="element-4060">
                        <UserIcon className="w-3 h-3" data-id="element-4061" /> {r.initiator}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-4062">
                      <div className="flex items-center gap-1 text-xs font-bold text-indigo-600 cursor-pointer hover:underline mb-1" onClick={() => setDetailPanel({
                    type: 'order_full',
                    title: `Заказ ${r.order}`,
                    data: {
                      id: r.order
                    }
                  })} data-id="element-4063">
                        {r.order}{' '}
                        <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-4064" />
                      </div>
                      {r.disputeId ? <div className="flex items-center gap-1 text-[10px] text-amber-600 font-medium cursor-pointer hover:underline" data-id="element-4065">
                          <Scale className="w-3 h-3" data-id="element-4066" /> {r.disputeId}
                        </div> : <div className="text-[10px] text-slate-400" data-id="element-4067">—</div>}
                    </td>
                    <td className="px-4 py-3" data-id="element-4068">
                      <div className="flex items-center gap-1.5 text-xs font-medium text-slate-900 cursor-pointer hover:text-indigo-600 mb-1" onClick={() => setDetailPanel({
                    type: 'user_profile',
                    title: `Пользователь`,
                    data: {
                      name: r.user
                    }
                  })} data-id="element-4069">
                        <UserIcon className="w-3 h-3 text-slate-400" data-id="element-4070" /> {r.user}
                      </div>
                      {r.astrologer !== '—' ? <div className="flex items-center gap-1.5 text-[11px] text-slate-600 cursor-pointer hover:text-indigo-600" onClick={() => setActiveTab('astrologers')} data-id="element-4071">
                          <StarIcon className="w-3 h-3 text-amber-400" data-id="element-4072" />{' '}
                          {r.astrologer}
                        </div> : <div className="text-[11px] text-slate-400" data-id="element-4073">—</div>}
                    </td>
                    <td className="px-4 py-3" data-id="element-4074">
                      <div className="text-sm font-bold text-rose-600 mb-0.5" data-id="element-4075">
                        {formatCurrency(r.amount)}
                      </div>
                      <div className="flex flex-col gap-0.5 text-[10px]" data-id="element-4076">
                        <span className="text-slate-500" data-id="element-4077">
                          Метод: {r.refundMethod}
                        </span>
                        {r.platformLoss > 0 && <span className="text-rose-600 font-medium" title="Потери платформы (комиссия + штрафы)" data-id="element-4078">
                            Потери: {formatCurrency(r.platformLoss)}
                          </span>}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-4079">
                      <div className="mb-1.5" data-id="element-4080">
                        <Badge variant={refundStatusConfig[r.status]?.variant || 'neutral'} size="sm" className="text-[10px]" data-id="element-4081">
                          {refundStatusConfig[r.status]?.label || r.status}
                        </Badge>
                      </div>
                      {r.risk && <div className="flex items-center gap-1 text-[10px] font-medium text-rose-600 bg-rose-50 px-1.5 py-0.5 rounded inline-flex" data-id="element-4082">
                          <AlertTriangle className="w-3 h-3" data-id="element-4083" /> {r.risk}
                        </div>}
                    </td>
                    <td className="px-4 py-3 text-right" data-id="element-4084">
                      <div className="flex items-center justify-end gap-1" data-id="element-4085">
                        {r.disputeId && <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<MessageSquare className="w-3.5 h-3.5" data-id="element-4087" />} onClick={() => success(`Открыт чат по спору ${r.disputeId}`)} title="Открыть чат" data-id="element-4086" />}
                        {r.consultation && <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<Video className="w-3.5 h-3.5" data-id="element-4089" />} onClick={() => success(`Открыта запись консультации ${r.consultation}`)} title="Открыть консультацию" data-id="element-4088" />}
                        <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<Eye className="w-3.5 h-3.5" data-id="element-4091" />} onClick={() => setSelectedRefundDetail(r)} title="Детализация" data-id="element-4090" />
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Refund Detail Modal */}
        {selectedRefundDetail && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" onClick={e => {
        if (e.target === e.currentTarget) setSelectedRefundDetail(null);
      }} data-id="element-4092">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in zoom-in-95 flex flex-col max-h-[90vh]" data-id="element-4093">
              <div className="flex items-center justify-between p-4 border-b border-slate-100 bg-slate-50 shrink-0" data-id="element-4094">
                <div className="flex items-center gap-2" data-id="element-4095">
                  <ArrowDownRight className="w-5 h-5 text-rose-600" data-id="element-4096" />
                  <h3 className="font-bold text-slate-900" data-id="element-4097">
                    Детализация возврата {selectedRefundDetail.id}
                  </h3>
                  <Badge variant={refundStatusConfig[selectedRefundDetail.status]?.variant || 'neutral'} size="sm" data-id="element-4098">
                    {refundStatusConfig[selectedRefundDetail.status]?.label}
                  </Badge>
                </div>
                <button onClick={() => setSelectedRefundDetail(null)} className="p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-200" data-id="element-4099">
                  <X className="w-5 h-5" data-id="element-4100" />
                </button>
              </div>

              <div className="overflow-y-auto p-6 space-y-6" data-id="element-4101">
                <div className="grid grid-cols-3 gap-4" data-id="element-4102">
                  <div className="p-4 rounded-xl bg-rose-50 border border-rose-100" data-id="element-4103">
                    <div className="text-xs text-rose-600 mb-1" data-id="element-4104">
                      Сумма возврата
                    </div>
                    <div className="text-xl font-bold text-rose-700" data-id="element-4105">
                      {formatCurrency(selectedRefundDetail.amount)}
                    </div>
                  </div>
                  <div className="p-4 rounded-xl bg-slate-50 border border-slate-100" data-id="element-4106">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-4107">
                      Комиссия возврата
                    </div>
                    <div className="text-xl font-bold text-slate-700" data-id="element-4108">
                      {formatCurrency(selectedRefundDetail.refundFee)}
                    </div>
                  </div>
                  <div className="p-4 rounded-xl bg-slate-50 border border-slate-100" data-id="element-4109">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-4110">
                      Потери платформы
                    </div>
                    <div className="text-xl font-bold text-rose-600" data-id="element-4111">
                      {formatCurrency(selectedRefundDetail.platformLoss)}
                    </div>
                  </div>
                </div>

                <div className="p-4 rounded-xl bg-slate-50 border border-slate-100" data-id="element-4112">
                  <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2" data-id="element-4113">
                    Причина возврата
                  </h4>
                  <p className="text-sm text-slate-700" data-id="element-4114">
                    {selectedRefundDetail.reason}
                  </p>
                </div>

                <div data-id="element-4115">
                  <h4 className="text-sm font-bold text-slate-900 mb-3 flex items-center gap-2" data-id="element-4116">
                    <History className="w-4 h-4 text-slate-400" data-id="element-4117" /> История
                    возврата
                  </h4>
                  <div className="space-y-4 relative before:absolute before:inset-0 before:ml-2.5 before:-translate-x-px before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-200 before:to-transparent" data-id="element-4118">
                    {selectedRefundDetail.log.map((event: any, idx: number) => <div key={idx} className="relative flex items-center gap-4 group is-active" data-id="element-4119">
                        <div className="flex items-center justify-center w-5 h-5 rounded-full border-2 border-white bg-slate-200 text-slate-500 shadow shrink-0 z-10" data-id="element-4120">
                          {event.status === 'success' ? <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-4121" /> : event.status === 'error' ? <XCircle className="w-3 h-3 text-rose-500" data-id="element-4122" /> : event.status === 'warning' ? <Clock className="w-3 h-3 text-amber-500" data-id="element-4123" /> : <Info className="w-3 h-3 text-slate-400" data-id="element-4124" />}
                        </div>
                        <div className="flex-1 p-3 rounded-lg border border-slate-200 bg-white shadow-sm flex justify-between items-center" data-id="element-4125">
                          <div className={`font-bold text-xs ${event.status === 'success' ? 'text-emerald-700' : event.status === 'error' ? 'text-rose-700' : event.status === 'warning' ? 'text-amber-700' : 'text-slate-700'}`} data-id="element-4126">
                            {event.action}
                          </div>
                          <div className="text-[10px] text-slate-500" data-id="element-4127">
                            {event.date}
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>

              <div className="p-4 border-t border-slate-100 flex justify-between items-center bg-slate-50 shrink-0" data-id="element-4128">
                <div className="flex gap-2" data-id="element-4129">
                  {selectedRefundDetail.disputeId && <Button variant="outline" size="sm" icon={<MessageSquare className="w-4 h-4" data-id="element-4131" />} onClick={() => success('Открыт чат по спору')} data-id="element-4130">
                      Открыть чат
                    </Button>}
                  <Button variant="outline" size="sm" icon={<ExternalLink className="w-4 h-4" data-id="element-4133" />} onClick={() => {
                setSelectedRefundDetail(null);
                setDetailPanel({
                  type: 'order_full',
                  title: `Заказ ${selectedRefundDetail.order}`,
                  data: {
                    id: selectedRefundDetail.order
                  }
                });
              }} data-id="element-4132">
                    Открыть заказ
                  </Button>
                </div>
                <div className="flex gap-2" data-id="element-4134">
                  <Button variant="outline" onClick={() => setSelectedRefundDetail(null)} data-id="element-4135">
                    Закрыть
                  </Button>
                  {selectedRefundDetail.status === 'reviewing' && <Button variant="primary" icon={<CheckCircle2 className="w-4 h-4" data-id="element-4137" />} onClick={() => {
                success('Возврат подтвержден');
                setSelectedRefundDetail(null);
              }} data-id="element-4136">
                      Подтвердить
                    </Button>}
                </div>
              </div>
            </div>
          </div>}
      </div>;
  };
  const renderPromos = () => <div className="space-y-4" data-id="element-4138">
      <div className="flex justify-between items-center" data-id="element-4139">
        <p className="text-sm text-slate-500" data-id="element-4140">
          Управление промокодами и скидками
        </p>
        <Button variant="primary" size="sm" icon={<Tag className="w-4 h-4" data-id="element-4142" />} onClick={() => success('Создание промокода')} data-id="element-4141">
          Создать промокод
        </Button>
      </div>
      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-4143">
        <div className="overflow-x-auto" data-id="element-4144">
          <table className="w-full text-left" data-id="element-4145">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-4146">
              <tr data-id="element-4147">
                <th className="px-4 py-3 font-medium" data-id="element-4148">ID</th>
                <th className="px-4 py-3 font-medium" data-id="element-4149">Код</th>
                <th className="px-4 py-3 font-medium" data-id="element-4150">Тип</th>
                <th className="px-4 py-3 font-medium" data-id="element-4151">Скидка</th>
                <th className="px-4 py-3 font-medium" data-id="element-4152">Ограничения</th>
                <th className="px-4 py-3 font-medium" data-id="element-4153">Использовано</th>
                <th className="px-4 py-3 font-medium" data-id="element-4154">Период</th>
                <th className="px-4 py-3 font-medium" data-id="element-4155">Статус</th>
                <th className="px-4 py-3 text-right font-medium" data-id="element-4156">Действия</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-4157">
              {mockPromos.map(p => <tr key={p.id} className="hover:bg-slate-50 transition-colors" data-id="element-4158">
                  <td className="px-4 py-3 text-xs font-bold text-indigo-600" data-id="element-4159">
                    {p.id}
                  </td>
                  <td className="px-4 py-3" data-id="element-4160">
                    <span className="text-sm font-mono font-bold text-slate-900 bg-slate-100 px-2 py-0.5 rounded" data-id="element-4161">
                      {p.code}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-700" data-id="element-4162">{p.type}</td>
                  <td className="px-4 py-3 text-sm font-bold text-emerald-600" data-id="element-4163">
                    {p.discount}
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-600 max-w-[150px] truncate" data-id="element-4164">
                    {p.restrictions}
                  </td>
                  <td className="px-4 py-3 text-xs font-medium text-slate-900" data-id="element-4165">
                    {p.used}
                  </td>
                  <td className="px-4 py-3 text-xs text-slate-500" data-id="element-4166">
                    {p.start} — {p.end}
                  </td>
                  <td className="px-4 py-3" data-id="element-4167">
                    <Badge variant={p.active ? 'success' : 'neutral'} size="sm" data-id="element-4168">
                      {p.active ? 'Активен' : 'Неактивен'}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-4169">
                    <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<Eye className="w-3.5 h-3.5" data-id="element-4171" />} data-id="element-4170" />
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
  return <div className="space-y-6" data-id="element-4172">
      <div data-id="element-4173">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-4174">Финансы</h2>
        <p className="text-sm text-slate-500" data-id="element-4175">
          Платежи, выплаты, возвраты и промокоды
        </p>
      </div>
      <Tabs tabs={[{
      id: 'payments',
      label: 'Платежи',
      content: renderPayments()
    }, {
      id: 'payouts',
      label: 'Выплаты',
      content: renderPayouts()
    }, {
      id: 'refunds',
      label: 'Возвраты',
      content: renderRefunds()
    }, {
      id: 'promos',
      label: 'Промокоды',
      content: renderPromos()
    }]} data-id="element-4176" />
    </div>;
}